import { GroupBase } from 'react-select';

import { TextFieldSelectProps } from './text-field-select.model';
import TextFieldSelectView from './text-field-select.view';

interface TextFieldSelectControllerProps<
  Option = unknown,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
> extends TextFieldSelectProps<Option, IsMulti, Group> {}

const TextFieldSelectController = <
  Option = unknown,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  props: TextFieldSelectControllerProps<Option, IsMulti, Group>
): JSX.Element => {
  return <TextFieldSelectView {...props} />;
};

export default TextFieldSelectController;
